var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 34
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 4373",
  width: 33,
  height: 32,
  rx: 5
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 6518",
  d: "M22.87 15.139a6.511 6.511 0 1 1-5.49-5.486 6.511 6.511 0 0 1 5.49 5.486Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 258",
  d: "M25.308 7.212h0"
}))));
export default SvgInstagram;